export { default } from './CompactView';
